export const allDocuments = [
  { key: "certificat_cession", label: "Certification de cession", cerfa: "15776*02" },
  { key: "demande_immatriculation_vn", label: "Demande d'immatriculation neuf", cerfa: "13749*05" },
  { key: "demande_immatriculation_vo", label: "Demande d'immatriculation occasion", cerfa: "13750*07" },
  { key: "mandat_particulier_garage", label: "Mandat particulier (Titulaire)", cerfa: "13757*03-titulaire" },
  { key: "mandat_particulier_garage_cotit", label: "Mandat particulier (Cotitulaire)", cerfa: "13757*03-cotitulaire" },
  { key: "mandat_particulier_garage_locataire", label: "Mandat particulier (Locataire)", cerfa: "13757*03-locataire" },
  { key: "mandat_professionnel", label: "Mandat professionnel" },
  { key: "declaration_achat", label: "Déclaration d'achat", cerfa: "13751*02" },
  { key: "confirmation_de_commande_client", label: "Confirmation de commande client", groups: [1006, 10] },
  { key: "controle_de_reception", label: "Contrôle de réception", groups: [1006, 10] },
  { key: "decharge_de_responsabilite", label: "Décharge de responsabilité", groups: [1006, 10] },
  { key: "procedure_de_mise_en_main", label: "Procédure de mise en main", groups: [1006, 10] },
  { key: "bon_de_prepa_atelier", label: "Bon de préparation atelier", groups: [1006, 10] },
  { key: "fiche_t", label: "Fiche T", groups: [1009] },
  { key: "etiquette_cle", label: "Etiquette Clé", groups: [1009] },
];

export const customDocuments = (vehiculeId, user, commonData) => [
  {
    key: 'confirmation_de_commande_client',
    filename: 'confirmation_de_commande_client.pdf',
    groups: [1006, 10],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId),
      nom_concession: user?.concession?.name || '',
      adresse_concession: user?.concession?.adresse || '',
      nom_client: commonData?.ccs_1 || '',
      adresse_client: `${commonData?.tit_12 || ''} ${commonData?.tit_14 || ''} ${commonData?.tit_15 || ''}, ${commonData?.tit_16 || ''} ${commonData?.tit_17 || ''}`,
      lieu: commonData?.sig_1 || '',
      date_du_jour: new Date().toLocaleDateString("fr-FR"),
      numero_dossier: commonData?.numero_dossier || '',
      marque_modele: `${commonData?.veh_1 || ''} ${commonData?.veh_2 || ''}`,
      nom_vendeur: user?.firstName + ' ' + user?.lastName,
      numero_apres_vente: user?.phone || '',
      numero_commercial: user?.id || '',
      email_concession: user?.email || '',
    })
  },
  {
    key: 'controle_de_reception',
    filename: 'controle_de_reception.pdf',
    groups: [1006, 10],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId),
      marque_modele: `${commonData?.veh_1 || ''} ${commonData?.veh_4 || ''}`,
      numero_dossier: commonData?.numero_dossier || '',
    })
  },
  {
    key: 'decharge_de_responsabilite',
    filename: 'decharge_de_responsabilite.pdf',
    groups: [1006, 10],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId)
    })
  },
  {
    key: 'procedure_de_mise_en_main',
    filename: 'procedure_de_mise_en_main.pdf',
    groups: [1006, 10],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId)
    })
  },
  {
    key: 'bon_de_prepa_atelier',
    filename: 'bon_de_prepa_atelier.pdf',
    groups: [1006, 10],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId)
    })
  },
  {
    key: 'fiche_t',
    filename: 'fiche_t.pdf',
    groups: [1009],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId)
    })
  },
  {
    key: 'etiquette_cle',
    filename: 'etiquette_cle.pdf',
    groups: [1009],
    getData: () => ({
      vehicule_id: parseInt(vehiculeId)
    })
  }
];